import type { Leaderboard, LeaderboardRank, LeaderboardSkillsDetail, SkillLog, SvelteFetch } from '$lib/api/types';
import { fetchJson, getJson } from '$lib/api/fetch';

export async function listStudentClasses(svelteFetch: SvelteFetch): Promise<Leaderboard[]> {
  return await getJson(`/studentactions/classes`, undefined, svelteFetch);
}

export async function acceptResearchConsent() {
  await fetchJson(`/studentactions/acceptresearchconsent`, 'POST', undefined, true);
}

export async function leaderboardOptIn(classId: number): Promise<Leaderboard> {
  return await fetchJson(`/studentactions/classes/${classId}/leaderboardoptin`, 'POST', undefined);
}

export async function leaderboardOptOut(classId: number): Promise<Leaderboard> {
  return await fetchJson(`/studentactions/classes/${classId}/leaderboardoptout`, 'POST', undefined);
}

// fetches the leaderboard record for the student and given class. the leaderboard record has information like clinical
// group id, opt-in status, and badge progress summary. The leaderboard record comes with class metadata including its
// course and badges.
export async function getClass(classId: number, svelteFetch?: SvelteFetch): Promise<LeaderboardSkillsDetail> {
  return await getJson(`/studentactions/classes/${classId}`, undefined, svelteFetch);
}

export async function getLeaderboard(classId: number, svelteFetch?: SvelteFetch): Promise<LeaderboardRank[]> {
  return await getJson(`/studentactions/classes/${classId}/leaderboard`, undefined, svelteFetch);
}

export async function addSkillLogEntries(classId: number, entries: SkillLog[]): Promise<{ studentRank?: number }> {
  return await fetchJson(`/studentactions/classes/${classId}/skilllog`, 'POST', entries);
}
